<template>
  <v-list flat subheader three-line>
    <v-list-item
      v-for="item in items"
      :disabled="disabled"
      :key="item.topic"
      @click="$emit('changeSubscription', item.topic)"
    >
      <v-list-item-action>
        <v-checkbox :input-value="item.hasSubscription"></v-checkbox>
      </v-list-item-action>

      <v-list-item-content>
        <v-list-item-title>
          {{ $t(`settings.notification.email.topic.${item.topic}.title`) }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ $t(`settings.notification.email.topic.${item.topic}.subtitle`) }}
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="item.hasSubscription">
          {{ $t(`settings.notification.activeSince`) }}
          {{ item.createdAt | date }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
    disabled: { type: Boolean, default: false },
  },
};
</script>
